import React from 'react';
import {
    Table,
    Row,
    Spin,
    Pagination, Tabs,
} from 'antd';
const TabPane = Tabs.TabPane;
import { asyncGet, actions,asyncProvinceGet } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';


class taskVolume extends React.Component {
    // state = {
    //     selectedRowKeys: [],
    // };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncProvinceGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    onSelectChange = selectedRowKeys => {
        this.props.getTransferData({ selectedRowKeys });
    }

    render() {
        let { list, uiStatus, pagination,listProvince } = this.props;
        //let { total, current, pageSize } = pagination;
        //let totalPage = Math.ceil(total / pageSize);
        let { isLoading } = uiStatus;
        const expandedRowRender = (dataJson, topId) => {
            let record = dataJson.tasks;
            if (record.length) {
                let cols = [
                    {
                        title: 'taskId',
                        dataIndex: 'taskId',
                        key: 'taskId',
                    },
                    {
                        title: 'eId',
                        dataIndex: 'eId',
                        key: 'eId',
                    },
                    {
                        title: 'ps',
                        dataIndex: 'ps',
                        key: 'ps',
                    },
                    {
                        title: '任务类型',
                        dataIndex: 'taskType',
                        key: 'taskType',
                    },
                    {
                        title: '任务来源',
                        dataIndex: 'taskSource',
                        key: 'taskSource',
                    },
                    {
                        title: '目标总量',
                        dataIndex: 'targetPv',
                        key: 'targetPv',
                    },
                ];
                  return (
                      <Table
                          columns={cols}
                          dataSource={record}
                          pagination={false}
                      />
                  );
            }else{
                return <span>出错</span>;
            }
        };
        const rowSelection = {
            //selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: '日期',
                dataIndex: 'date',
                key: 'date',
                sorter: (a, b) => Date.parse(new Date(a.date)) - Date.parse(new Date(b.date)),
            },
            {
                title: '曝光总任务量',
                dataIndex: 'evTargetPv',
                key: 'evTargetPv',
                sorter: (a, b) => a.evTargetPv - b.evTargetPv,
            },
            {
                title: '点击总任务量',
                dataIndex: 'clickTargetPv',
                key: 'clickTargetPv',
                sorter: (a, b) => a.clickTargetPv - b.clickTargetPv,
            },
            {
                title: '曝光已完成量',
                dataIndex: 'evFinishedPv',
                key: 'evFinishedPv',
                sorter: (a, b) => a.evFinishedPv - b.evFinishedPv,
            },
            {
                title: '点击已完成量',
                dataIndex: 'clickFinishedPv',
                key: 'clickFinishedPv',
                sorter: (a, b) => a.clickFinishedPv - b.clickFinishedPv,
            },
            {
                title: '9点后任务数',
                dataIndex: 'gt90',
                key: 'gt90',
                sorter: (a, b) => a.gt90 - b.gt90,
            },
            {
                title: '9点前任务数',
                dataIndex: 'lt90',
                key: 'lt90',
                sorter: (a, b) => a.lt90 - b.lt90,
            },
        ];

        const columnsProvince = [
            {
                title: '地区',
                dataIndex: 'province',
                key: 'province',
            },
            {
                title: '任务类型',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: '曝光任务量',
                dataIndex: 'evTargetPv',
                key: 'evTargetPv',
                sorter: (a, b) => a.evTargetPv - b.evTargetPv,
            },
            {
                title: '点击任务量',
                dataIndex: 'clickTargetPv',
                key: 'clickTargetPv',
                sorter: (a, b) => a.clickTargetPv - b.clickTargetPv,
            },
            {
                title: '日期',
                dataIndex: 'date',
                key: 'date',
                sorter: (a, b) => Date.parse(new Date(a.date)) - Date.parse(new Date(b.date)),
            },
            {
                title: '9点后任务数',
                dataIndex: 'gt90',
                key: 'gt90',
                sorter: (a, b) => a.gt90 - b.gt90,
            },
            {
                title: '9点前任务数',
                dataIndex: 'lt90',
                key: 'lt90',
                sorter: (a, b) => a.lt90 - b.lt90,
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="按日期" key="1">
                            <Table
                                columns={columns}
                                dataSource={list}
                                defaultExpandAllRows={false}
                                pagination={false}
                            />
                        </TabPane>
                        <TabPane tab="按地区" key="2">
                            <Table
                                columns={columnsProvince}
                                dataSource={listProvince}
                                //expandedRowRender={record => expandedRowRender(record, record.province)}
                                pagination={false}
                            />
                        </TabPane>
                    </Tabs>

                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.taskVolume.list,
    listProvince: state.taskVolume.listProvince,
  //  pagination: state.taskVolume.pagination,
    uiStatus: state.taskVolume.uiStatus,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    asyncProvinceGet:() => dispatch(asyncProvinceGet()),
});
export default connect(mapStateToProps, mapDispatchToProps)(taskVolume);






// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/taskVolume/index.js